import React from "react";
import PendingAddressesView from "../../views/adminView/pendingAddresses/PendingAddresses";

export default function PendingAddressesPage() {
  return <PendingAddressesView />;
}
